import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import { useRecoilValue } from "recoil";
import { loginState } from "../../stores/loginState";
import Swal from "sweetalert2";

// TODO 업무구분 수정 API
export const useEditTmDv = (sendInvoiceMutate) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인 전역변수
  const apiInstance = login.company === "LOGEN" ? LogenInstance : LotteInstance; // 고객사

  // TODO API 결과
  return useMutation(
    (data) =>
      apiInstance.post("/distinguish", data),
    {
      // 성공 시
      onSuccess: (data) => {
        if (data.result === "00" || data.result === "77") {
          sendInvoiceMutate();
          Swal.fire({
            title: "성공!",
            icon: "success",
            text: "업무구분을 성공적으로 수정하였습니다!",
            confirmButtonText: "확인"
          });
        // 서버 문제 발생 시 
        } else if (data.result === "fail") {
          Swal.fire({
            title: "Error!",
            icon: "error",
            text: "업무구분 수정에 실패했습니다. 다시 시도해주세요.",
            confirmButtonText: "확인",
          });
        }
      },
      // 실패 시
      onError: (error) => {
        console.log(error);
      },
    }
  );
};
